import clsx from 'clsx'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import { Text } from '@wartek-id/text'

import Header from 'app/BuktiKaryaPage/components/Header'
import BlockIdentity from './QualificationBlocks/BlockIdentity'
import BlockCertification from './QualificationBlocks/BlockCertification'
import BlockQualification from './QualificationBlocks/BlockQualification'
import BlockAllocation from './QualificationBlocks/BlockAllocation'
import { useAPIGetKepalaSekolahEligibility } from 'api/bcks/useAPIBCKSQualification'
import {
  GeneralNoticeState,
  OfflineNoticeState as OnlineOnly,
} from 'components/NoticeState'
import BlockContact from './QualificationBlocks/BlockContact'
import BannerQualification from './QualificationBlocks/BannerQualification'
import useKSPSTrackEvent from './hooks/useKSPSTrackEvent'

const QualificationCheckPage = () => {
  const router = useRouter()
  const { KSPSTrackEvent } = useKSPSTrackEvent()
  const [isOnline, setIsOnline] = useState<boolean>(
    window?.navigator?.onLine || false
  )
  const { data, isLoading, isError } = useAPIGetKepalaSekolahEligibility()

  useEffect(() => {
    if (data) {
      KSPSTrackEvent({
        event_name: 'enter_ks_selection_eligibility_check_eligible',
        additional_info: [
          {
            key: 'is_eligible',
            value: data?.status,
          },
        ],
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <div
      className={clsx({
        'relative flex flex-col min-h-screen max-w-xl mx-auto': true,
        'bg-white': isError || !isOnline,
        'bg-surface-subdued': !isError && isOnline,
      })}
    >
      <Header
        title={
          data?.currentAssignment.periodePenugasan > 0
            ? 'Profil Kepala Sekolah'
            : 'Kualifikasi Anda'
        }
        forceNavigateBack
      />

      <div className="p-4 space-y-3">
        <OnlineOnly
          showButton
          noticeContainerClassNames="pt-10 pb-7"
          onButtonClick={() => router.reload()}
          onStatusChange={(v) => setIsOnline(v)}
        >
          <>
            {isError && (
              <div
                style={{
                  height: 'calc(100vh - 3.5rem)',
                  overflow: 'auto',
                }}
              >
                <div className="pt-11">
                  <GeneralNoticeState
                    containerClassNames="pt-10 pb-7"
                    showButton
                    onButtonClick={() => router.reload()}
                  />
                </div>
              </div>
            )}

            {!isError && (
              <>
                {!isLoading && <BannerQualification variant={data.status} />}

                <>
                  {!isLoading && data.status === 'VALID' && (
                    <div className="border border-success-default px-4 py-6 bg-surface-subdued rounded text-center">
                      <Text color="subdued" variant="body-sm">
                        Jika ditemukan ketidaksesuaian data berdasarkan regulasi
                        yang berlaku, maka seluruh proses dapat dibatalkan.
                      </Text>
                    </div>
                  )}
                </>

                {/* These two blocks will display loading icon if it's still loading */}
                {/* Block: Identity */}
                <BlockIdentity isLoading={isLoading} data={data?.identity} />

                {/* Block: Sertifikasi */}
                <BlockCertification
                  isLoading={isLoading}
                  data={data?.certificate}
                />

                {/* These three remaining blocks will be hidden while it's loading, as it's not necessary to display all 5 blocks just to let the user know if it's loading */}
                {!isLoading && (
                  <>
                    {/* Block: Kualifikasi & Kepegawaian */}
                    <BlockQualification data={data.qualification} />

                    {/* Block: Penugasan Saat Ini */}
                    <BlockAllocation data={data.currentAssignment} />

                    {/* Block: Contact */}
                    <BlockContact data={data.contact} />
                  </>
                )}

                <div>
                  <Text variant="body">Catatan:</Text>
                  <ul className="list-disc pl-5">
                    <li>
                      <Text variant="body">
                        Jika data sudah diperbarui operator Dinas, data akan
                        otomatis berubah di Ruang GTK dalam 1-2 hari
                      </Text>
                    </li>
                    <li>
                      <Text variant="body">
                        Jika data belum berubah, silakan cek ke operator di luar
                        Ruang GTK untuk diperbarui
                      </Text>
                    </li>
                  </ul>
                </div>
              </>
            )}
          </>
        </OnlineOnly>
      </div>
    </div>
  )
}
export default QualificationCheckPage
